export default "__VITE_ASSET__BK$USpRu__"